import { I18nContext } from '@bingads-webui-react/i18n-context';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useCallback, useContext, useEffect } from 'react';
import { isEmpty } from 'underscore';
import { keyCode } from '@bingads-webui/keycode';
import { Icon } from '@bingads-webui-react/fabric-control';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './style';


const Creative = ({
  creative,
  index,
  currentIndex,
  setCurrentIndex,
  switchCreative,
}) => {
  const clickFunc = useCallback(() => {
    setCurrentIndex(index);
    switchCreative(creative);
  }, [index, setCurrentIndex, switchCreative, creative]);

  const onKeyDown = useCallback((ev) => {
    if (ev.keyCode === keyCode.Enter) {
      clickFunc();
    }
  }, [clickFunc]);

  return (
    <div
      className={classNames('creative-decorator', index === currentIndex ? 'selected' : '')}
      onClick={clickFunc}
      role="button"
      tabIndex={0}
      onKeyDown={onKeyDown}
    >
      <div className="creative-box">
        <img src={creative.url} alt="creative" />
      </div>
    </div>
  );
};

export const HistoryBanner = (props) => {
  const { creativeList, switchCreative } = props;
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(creativeList.length - 1);
  }, [creativeList]);

  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classNames('history-box', classes.banner)}>
      <div className="history-title-container">
        <Icon iconName="History" className="history-icon" />
        <div className="history-title">{i18n.getString(_TL_('History'))}</div>
      </div>
      <div className="history-list-container">
        {
          !isEmpty(creativeList) && (
            <div className="history-list">
              {
                creativeList.map((creative, index) => (
                  <Creative
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                    creative={creative}
                    index={index}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    switchCreative={switchCreative}
                  />
                ))
              }
            </div>
          )
        }
      </div>
    </div>);
};

HistoryBanner.propTypes = {
  creativeList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  switchCreative: PropTypes.func.isRequired,
};

HistoryBanner.defaultProps = {
};
